import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';
import { GlobalService } from './global.service';
import { SearchResult } from 'src/domain/searchResults/searchResult';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  endpoint = this.globalService.endpoint;

  constructor(private http: HttpClient, private auth: AuthService, private globalService: GlobalService) { }

  /**
   * Recupera tutte le postazioni relative all'account
   */
  public getPostazioni() {
    const url = this.endpoint + 'settings/postazioni';
    const params = {
      PageSize: 1000
    };
    return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      this.auth.updateToken(result.TokenAnswer);
      return result;
    }));
  }

  /**
   * Recupera i parametri per la vendita
   */
  public getParametriVendita() {
    const url = this.endpoint + 'settings/parametrivendita';
    const params = {};
    return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      this.auth.updateToken(result.TokenAnswer);
      return result;
    }));
  }

  public getGiorniRicercaCassa() {
    const url = this.endpoint + 'settings/giorniricercacassa';
    const params = {};
    return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      this.auth.updateToken(result.TokenAnswer);
      return result;
    }));
  }

  public getParametriRiparazione() {
    const url = this.endpoint + 'settings/parametririparazione';
    const params = {};
    return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      this.auth.updateToken(result.TokenAnswer);
      return result;
    }));
  }

  public getParametriApp() {
    const url = this.endpoint + 'settings/parametriapp';
    const params = {};
    return this.http.post<SearchResult>(url, params, {headers: this.globalService.getHeaders()}).pipe(map(result => {
      this.auth.updateToken(result.TokenAnswer);
      return result;
    }));
  }

}
